import { ProjectType } from "@/types/type"

//texts 를 번역만 함
const translationTexts = async (texts: Array<String>, target_lang: String) => {
  const result = await fetch(`/api/utils/translation`, {
    method: "PUT",
    body: JSON.stringify({text: texts, target_lang})
  })
  .then((res) =>res.json())
  .then(res => res.data.data)
  return result
}

//project를 통으로 번역하고 저장하고 리턴
const translationProject = async (
  project: any, 
  target_lang: String, 
  voices: Array<Tts>, 
  onlyTranslateScript: boolean,
  folderId?: string,  //번역된 프로젝트를 저장할 폴더 아이디
  projectId?: string  //이미 번역된적 있는 프로젝트인 경우 해당 프로젝트 아이디를 같이 전달
) => {
  if(!project) return null
  if(!target_lang) return null

  const result = await fetch(`/api/utils/translation`, {
    method: "POST",
    body: JSON.stringify({
      project, 
      target_lang, 
      type: "project", 
      voices, 
      onlyTranslateScript, 
      folderId,
      projectId
    })
  })
  .then((res) =>res.json())
  .then(res => res.data.data)
  // console.log("!@#!@#!@# utils result ", result);
  return result
}

const getPreTranslatedProjectsByFolderId = async (
  folderId: string
) => {
  const result = await fetch(`/api/utils/translation?folderId=${folderId}`, {
    method: "GET"
  })
  .then((res) =>res.json())
  .then(res => res.data.data)
  console.log("!@#!@#!@# getPreTranslatedProjectsByFolderId result ", result);
  return result

}

export {
  translationProject,
  translationTexts,
  getPreTranslatedProjectsByFolderId
}


